namespace Gamification.Gamification {
    export interface UtentiProdottiClassiRow {
        IdUtenteProdottoClasse?: number;
        UserId?: number;
        TenantId?: number;
        IdUtente?: number;
        IdUtenteProdotto?: number;
        IdProdottoClasse?: number;
        IdProdottoClasseNome?: string;
    }

    export namespace UtentiProdottiClassiRow {
        export const idProperty = 'IdUtenteProdottoClasse';
        export const nameProperty = 'UserId';
        export const localTextPrefix = 'Gamification.UtentiProdottiClassi';
        export const lookupKey = 'Gamification.UtentiProdottiClassi';

        export function getLookup(): Q.Lookup<UtentiProdottiClassiRow> {
            return Q.getLookup<UtentiProdottiClassiRow>('Gamification.UtentiProdottiClassi');
        }
        export const deletePermission = 'Gamification:Prodotti';
        export const insertPermission = 'Gamification:Prodotti';
        export const readPermission = 'Gamification:Prodotti';
        export const updatePermission = 'Gamification:Prodotti';

        export declare const enum Fields {
            IdUtenteProdottoClasse = "IdUtenteProdottoClasse",
            UserId = "UserId",
            TenantId = "TenantId",
            IdUtente = "IdUtente",
            IdUtenteProdotto = "IdUtenteProdotto",
            IdProdottoClasse = "IdProdottoClasse",
            IdProdottoClasseNome = "IdProdottoClasseNome"
        }
    }
}
